import React from 'react';
import { Container, Grid } from '@mui/material';
import IndexNumber from '../Components/Typography/IndexNumber';
import Heading from '../Components/Typography/Heading';
import AboutMe from '../Components/AboutMe';
import ContentWrapper from '../Components/ContentWrapper';
import { EarlyWrapper } from '../Components/animation/EarlyWrapper';
import { LateWrapper } from '../Components/animation/LateWrapper';
import { DelayedWrapper } from '../Components/animation/DelayedWrapper';

const ContactMe = () => {
  return (
    <ContentWrapper>
      <Container maxWidth='xxl'>
        <Grid container spacing={2}>
          {/* -----Number------- */}
          <Grid item xs={12} md={2} xl={2} xxl={2}>
            <EarlyWrapper>
              <IndexNumber number='04 /' />
            </EarlyWrapper>
          </Grid>
          {/* --------- Intro ----------- */}
          <Grid item xs={12} md={10} xl={10} xxl={10}>
            <LateWrapper>
              <Heading content='Connect with Me' />
            </LateWrapper>
            {/* ------ Contact Me-------- */}
            <DelayedWrapper>
              <AboutMe />
            </DelayedWrapper>
          </Grid>
        </Grid>
      </Container>
    </ContentWrapper>
  );
};

export default ContactMe;
